import * as constants from "../constants.js";
import notifications from "../notifications"

export default {
    OnSuccess(description) {
        notifications.Success("Mensagens", description);
    },

    OnError(resp, description) {
        notifications.Error("Mensagens", description);       
    },
    
    OnUnauthorized(){
        window.location = "/";
    },

    GetLeads: async function (size, num, orderDirection, searchTerm, status, filter, orderBy) {
        
        let reqUriParams = `orderDirection=${orderDirection}`;
        if (num != '') {
            reqUriParams += `&PageNum=${num}`;
        }
        if (size != '') {
            reqUriParams += `&PageSize=${size}`;
        }
        if (searchTerm !== '') {
            reqUriParams += `&Filter.SearchTerm=${encodeURI(searchTerm)}`;
        }
        if (orderBy != "" && orderBy != undefined) {
            reqUriParams += `&OrderBy=${orderBy}`;
        }
        if (filter != null) {
            if (filter.FilterBy != null) {
                reqUriParams += `&Filter.FilterBy=${filter.FilterBy}`;
            }
            var IdAppUser = new URL(location.href).searchParams.get("IdBuyer")
            if (IdAppUser != null) {
                var type = new URL(location.href).searchParams.get("Type")
                if (type == null || type == "") type = "1";
                reqUriParams += `&Filter.IdBuyer=${IdAppUser}&Filter.Type=${type}`;
            }
            var IdAd = new URL(location.href).searchParams.get("IdAd")

            if (IdAd != null) {
                reqUriParams += `&Filter.IdAd=${IdAd}`;
            }
        }

        let result = await fetch(`${constants.API_ENDPOINT_LEADS}?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao pesquisar as Mensagens");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    UploadPhoto: async function (idAd, idLead, file) {
        let reqUri = `${constants.API_ENDPOINT_LEADS}/${idAd}/messages/${idLead}/photos`;
        var formData = new FormData();
        formData.append('file', file);

        let result = await fetch(reqUri, { 
                            method: constants.HTTP_METHOD_POST,
                            body: formData
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao carregar a Fotografia");
                                    return null;
                                }else if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                }else{
                                    this.OnError(resp, "Ocorreu uma anomalia ao fazer o upload da Fotografia");
                                    return null;
                                }
                            } else {
                                if (resp.status == 200) {
                                    this.OnSuccess("Fotografia adicionada com sucesso");
                                }else{
                                    this.OnError(resp, "Ocorreu uma anomalia ao fazer o upload da Fotografia");
                                    return null;
                                }
                            }

                            return resp.json();
                        });

        return result;
    },
    GetStats: async function (searchTerm, IdAppUser, IdAd) {
        let reqUriParams = `orderDirection=ASC`;

        if (IdAppUser != null) {
            reqUriParams += `&Filter.IdBuyer=${IdAppUser}`;
        }
        
        if (IdAd != null) {
            reqUriParams += `&Filter.IdAd=${IdAd}`;
        }
        if (searchTerm !== '') {
            reqUriParams += `&SearchTerm=${encodeURI(searchTerm)}`;
        }

        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/stats?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao obter os Contadores");
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    GetLead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao carregar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    GetLeadMessages: async function (idlead, num, size) {
        let reqUriParams = `orderDirection=ASC`;
        if (num != '') {
            reqUriParams += `&PageNum=${num}`;
        }
        if (size != '') {
            reqUriParams += `&PageSize=${size}`;
        }

        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/messages?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao ler as Mensagens");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    SetAdvertiserMessagesAsRead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/adv-readed`, {
            method: constants.HTTP_METHOD_PUT
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao ler a Mensagem do anúnciante");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    // CreateLead: async function (formData) {
    //     let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/adv-readed`, {
    //         method: constants.HTTP_METHOD_POST,
    //         headers: constants.HTTP_HEADERS_JSON,
    //         body: JSON.stringify(formData)
    //     })
    //         .then(resp => {
    //             if (!resp.ok) {
    //                 if (resp.status == 500) {
    //                     this.OnError(resp);
    //                     return null;
    //                 }
    //             }

    //             return resp.json();
    //         });

    //     return result;
    // },

    CreateLeadMessage: async function (idLead, formData) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idLead}/messages`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(formData)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao criar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    SetUserMessagesAsRead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/usr-readed`, {
            method: constants.HTTP_METHOD_PUT,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao ler a Mensagem do utilizador");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    ArchiveLead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/archive`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao arquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagem arquivada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    UnarchiveLead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/unarchive`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao arquivar a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagem arquivada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },

    DeleteLead: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/`, {
            method: constants.HTTP_METHOD_DELETE,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(idlead)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao remover a Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Mensagem eliminada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
    GetLeadBuyerInfo: async function (idlead) {
        let result = await fetch(`${constants.API_ENDPOINT_LEADS}/${idlead}/buyer`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao carregar os dados da Mensagem");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

}